import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintSBUM = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSBUM = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>SURAT PERMOHONAN SUBSIDI BANTUAN UANG MUKA (SBUM)</div>
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>
            <div>Kepada Yth:</div>
            <div style={{ fontWeight: "bold" }}>Kepala Satuan Kerja Direktorat Jenderal Pembiayaan Perumahan</div>
            <div>Kementerian Pekerjaan Umum dan Perumahan Rakyat</div>
            <div>Jalan Raden Patah 1 No 1 Lantai 2 Wing 3.</div>
            <div>Kebayoran Baru, Jakarta Selatan 12110</div>
          </div>
          <div style={{ marginTop: "10px", fontWeight: "bold" }}>Perihal : Permohonan Subsidi Bantuan Uang Muka (SBUM)</div>
          <span>Saya yang bertanda tangan dibawah ini :</span>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tgl Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{""}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "20px" }}>mengajukan permohonan Subsidi Bantuan Uang Muka untuk pembelian rumah sejahtera tapak dengan keterangan sebagai berikut:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "220px" }}>Nama Pengembang</td>
                <td style={{ width: "15px" }}>:</td>
                <td> {companyName ?? "-"}</td>
              </tr>
              <tr>
                <td>Alamat Rumah Yang Dibeli</td>
                <td>:</td>
                <td> {item.sales_branch?.branch_address[0]?.description}</td>
              </tr>
              <tr>
                <td>Harga Jual Rumah</td>
                <td>:</td>
                <td>{currencyFormat(item.sales_detail[0]?.amount)}</td>
              </tr>
              <tr>
                <td>Besaran Uang Muka</td>
                <td>:</td>
                <td>{currencyFormat(item.sales_detail[0]?.price_dp)}</td>
              </tr>
              <tr>
                <td>Bank Pelaksana</td>
                <td>:</td>
                <td>{"Bank BTN KC Harapan Indah"}</td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "15px" }}>Sebagai pertimbangan, bersama ini kami lampirkan dokumen fotokopi surat pengakuan kekurangan bayar uang muka pembelian rumah sejahtera tapak yang disetujui oleh ………………………………………….……………………………………*)</p>
          <p>Dengan surat permohonan ini saya menyatakan telah memahami dan tunduk pada ketentuan Pemerintah yang mengatur Subsidi Bantuan Uang Muka (SBUM). Apabila dikemudian hari saya tidak dapat menjalankan ketentuan Pemerintah tersebut di atas yang mengakibatkan Pemerintah mencabut semua kemudahan dan subsidi terkait kemudahan dalam perolehan rumah, saya bersedia mengembalikan semua kemudahan dan subsidi yang telah saya terima tersebut.</p>
          <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih.</p>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>..........................</div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "end",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                {item.sls_appl?.name ?? "-"}
                <br />
                <span style={{ fontWeight: "normal" }}>Nasabah</span>
              </div>
            </div>
          </div>

          <div style={{ marginTop: "20px" }}>*) diisi dengan nama direktur atau yang mewakili pengemban dan nama perusahaan/pengembang</div>
        </div>
      </div>
    </div>
  );
};
